export const ItKindOptions = ({placeholder = 'All kinds'}) => {
  const kinds = useItKinds().sort((a, b) => a.name.localeCompare(b.name))

  return pug`
    option(value='')= placeholder
    for kind in kinds
      option(key=kind.id value=kind.id)= kind.name
  `
}
